const TermsAndConditionsKeys = {
  TITLE: "title",
  ID: "id",
  CONTENT: "content",
  VERSION_NUMBER: "versionNumber",
  CREATED_BY: "createdBy",
  CREATED_DATE: "createdDate",
  VERSION: "version",
  ACTIVE: "active",
  Validations:{
    ERROR_MSG_MAX_LENGTH : "validations.errMsgMaxLength"
  }  
}

export default TermsAndConditionsKeys
